export const NAMESPACES = [
  'common',
  'nav',
  'home',
  'features',
  'how-it-works',
  'pricing',
  'faq',
  'download',
  'changelog',
  'auth',
  'account',
  'legal',
  'errors',
  'seo',
] as const;

export type Namespace = (typeof NAMESPACES)[number];
export const DEFAULT_NS: Namespace = 'common';

export const LANGUAGES = ['en'] as const;
export type Language = (typeof LANGUAGES)[number];
export const FALLBACK_LANGUAGE: Language = 'en';
